export const styles = {
    body: {
        fontFamily: "'Source Sans Pro', Helvetica, sans-serif",
        lineHeight: 1.6,
    },
    container: {
        maxWidth: ['100%', '100%', 920],
        width: '100%',
        padding: ['20px', '0 40px 40px'],
    },
    h1: {
        margin: ['30px 0 20px', '60px 0 20px', '40px 0 30px'],
        fontFamily: '"Playfair Display", serif',
        fontSize: [50, 50, 70],
        fontWeight: 700,
        letterSpacing: '-0.02em',
    },
    h2: {
        margin: ['40px 0 20px', '40px 0 30px'],
        lineHeight: ['1.2em', '1.5em'],
        fontFamily: '"Poppins", serif',
        fontWeight: 400,
        fontSize: 32,
        letterSpacing: '-0.02em',
    },
    h3: {
        margin: '25px 0 10px',
        fontSize: 22,
        fontWeight: 400,
    },
    h4: {
        margin: '25px 0 10px',
        fontSize: 18,
        fontWeight: 400,
    },
    h5: {
        margin: '20px 0 10px',
        fontSize: 16,
        fontWeight: 400,
    },
    h6: {
        margin: '20px 0 10px',
        fontSize: 16,
        fontWeight: 400,
        textTransform: 'uppercase',
    },
    ol: {
        padding: 0,
        margin: '10px 0 10px',
    },
    ul: {
        padding: 0,
        margin: '10px 0 10px',
    },
    playground: {
        padding: ['1.5em', '2em'],
    },
    code: {
        margin: '0 3px',
        padding: '4px 6px',
        borderRadius: '3px',
        fontFamily: '"Source Code Pro", monospace',
        fontSize: '0.85em',
    },
    pre: {
        fontFamily: '"Source Code Pro", monospace',
        fontSize: 14,
        lineHeight: 1.8,
    },
    paragraph: {
        margin: '10px 0 20px 0',
    },
    table: {
        overflowY: 'hidden',
        overflowX: ['initial', 'initial', 'initial', 'hidden'],
        display: ['block', 'block', 'block', 'table'],
        width: '100%',
        fontFamily: '"Source Code Pro", monospace',
        fontSize: 14,
    },
    blockquote: {
        margin: '25px 0',
        padding: '20px',
        fontStyle: 'italic',
        fontSize: 18,
    },
    hr: {},
    link: {},
};
//# sourceMappingURL=data:application/json;base64,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